export default "__VITE_ASSET__c2a403b2__"